import _isNil from 'lodash/isNil';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import { EMPTY_ARRAY, EMPTY_STRING } from 'commons-ui';

import { ACTION, PAGE_NAMES, USER_PROFILE_RESOURCES } from 'constant';
import { KYC_STATUS_VALUE, MANUAL_VERIFICATION_OPTIONS, MANUAL_VERIFICATION_REQ_LABEL, VIEW_FIELD_KEYS } from '../constants';
import { ACTION_IDS, ACTION_LABELS } from './constants';

export const makeActionList = (params?: any) => {
	const { keyConfig, manualVerificationRequired, hasPermissionV2 } = params;

	switch (_get(keyConfig, 'name', EMPTY_STRING)) {
		case VIEW_FIELD_KEYS.KYC_STATUS:
			return [
				{
					id: ACTION_IDS.APPROVE,
					label: ACTION_LABELS[ACTION_IDS.APPROVE],
					isEnabled: ({ keyData }: { keyData: any }) =>
						!_isNil(keyData) &&
						!_isEmpty(keyData) &&
						manualVerificationRequired === MANUAL_VERIFICATION_REQ_LABEL[MANUAL_VERIFICATION_OPTIONS.REQ] &&
						(keyData === KYC_STATUS_VALUE.REJECTED ||
							keyData === KYC_STATUS_VALUE.PENDING ||
							keyData === KYC_STATUS_VALUE.NAME_MISMATCH) &&
						hasPermissionV2({
							configPageName: PAGE_NAMES.userProfile,
							configResourceName: USER_PROFILE_RESOURCES.kycDetails,
							configActionName: ACTION.updateKYCStatus
						})
				},
				{
					id: ACTION_IDS.REJECT,
					label: ACTION_LABELS[ACTION_IDS.REJECT],
					isEnabled: ({ keyData }: { keyData: any }) =>
						!_isNil(keyData) &&
						!_isEmpty(keyData) &&
						(keyData === KYC_STATUS_VALUE.APPROVED ||
							keyData === KYC_STATUS_VALUE.PENDING ||
							keyData === KYC_STATUS_VALUE.NAME_MISMATCH) &&
						hasPermissionV2({
							configPageName: PAGE_NAMES.userProfile,
							configResourceName: USER_PROFILE_RESOURCES.kycDetails,
							configActionName: ACTION.updateKYCStatus
						})
				},
				{
					id: ACTION_IDS.UPLOAD,
					label: ACTION_LABELS[ACTION_IDS.UPLOAD],
					isEnabled: ({ keyData }: { keyData: string }) =>
						!_isEmpty(keyData) &&
						(keyData === KYC_STATUS_VALUE.NOT_INITIATED ||
							keyData === KYC_STATUS_VALUE.REJECTED ||
							keyData === KYC_STATUS_VALUE.ERROR) &&
						hasPermissionV2({
							configPageName: PAGE_NAMES.userProfile,
							configResourceName: USER_PROFILE_RESOURCES.kycDetails,
							configActionName: ACTION.submitKyc
						})
				}
			];
		default:
			return EMPTY_ARRAY;
	}
};

export default {
	makeActionList
};
